"use client"
import { useEffect } from "react";

function useCustomEventListener(eventName: string, handler: (e: Event) => void) {
    useEffect(() => {
        window.addEventListener(eventName, handler);

        return () => {
            window.removeEventListener(eventName, handler);
        };
    }, [eventName, handler]);
}

export default useCustomEventListener;
